import Vue from 'vue'
import Router from 'vue-router'

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

var os = function () {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc
  };
}();
var router
if (os.isAndroid || os.isPhone || os.isTablet) {
  router = new Router({
    mode: 'history',
    base: '/dingding-download/',
    routes: [
      {
        path: '/',
        component: require('../views/mobile/workNum').default
      },
      {
        path: '/workNum',
        name: 'workNum_m',
        component: require('../views/mobile/workNum').default
      },
      {
        path: '/phoneNum',
        name: 'phoneNum_m',
        component: require('../views/mobile/phoneNum').default
      },
      {
        path: '/userInfo',
        name: 'userInfo_m',
        component: require('../views/mobile/userInfo').default
      },
      {
        path: '/download',
        name: 'download_m',
        component: require('../views/mobile/download').default
      }
    ]
  })

} else if (os.isPc) {
  router = new Router({
    mode: 'history',
    base: '/dingding-download/',
    routes: [
      {
        path: '/',
        component: require('../views/pc/workNum').default
      },
      {
        path: '/workNum',
        name: 'workNum_pc',
        component: require('../views/pc/workNum').default
      },
      {
        path: '/phoneNum',
        name: 'phoneNum_pc',
        component: require('../views/pc/phoneNum').default
      },
      {
        path: '/userInfo',
        name: 'userInfo_pc',
        component: require('../views/pc/userInfo').default
      },
      {
        path: '/download',
        name: 'download_pc',
        component: require('../views/pc/download').default
      }
    ]
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js